import { useState, useEffect } from "react";
import { Reveal } from "@/components/Reveal";

const diff = (target) => {
  const d = Math.max(0, new Date(target) - Date.now());
  return {
    days: Math.floor(d / 86400000),
    hours: Math.floor(d / 3600000) % 24,
    minutes: Math.floor(d / 60000) % 60,
    seconds: Math.floor(d / 1000) % 60,
  };
};

export const Countdown = ({ t }) => {
  const [left, setLeft] = useState(() => diff(t.countdown.target));

  useEffect(() => {
    const id = setInterval(() => setLeft(diff(t.countdown.target)), 1000);
    return () => clearInterval(id);
  }, [t.countdown.target]);

  return (
    <section data-testid="countdown-section" className="py-20 sm:py-24 px-6 border-y border-[#F4F0E6]/10 bg-[#1A1715]">
      <div className="max-w-5xl mx-auto text-center">
        <Reveal>
          <p className="font-heading italic text-2xl sm:text-3xl text-[#A8A294]">{t.countdown.title}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 grid grid-cols-4 gap-4 sm:gap-10 max-w-2xl mx-auto" data-testid="countdown-values">
            {["days", "hours", "minutes", "seconds"].map((unit) => (
              <div key={unit}>
                <p className="font-heading text-5xl sm:text-7xl text-[#D4A373] tabular-nums" data-testid={`countdown-${unit}`}>
                  {String(left[unit]).padStart(2, "0")}
                </p>
                <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#A8A294] mt-2">{t.countdown.labels[unit]}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
